import { defineStore } from 'pinia'
import useBcSelectedStore from './bcSelected'
import findIndex from 'lodash/findIndex'

// initial state
const state = () => ({
  selected: [],
})

// functionName: (state, getters, rootState) => {}
const getters = {
  
}

// functionName ({ commit, state, dispatch }, param, ...) {}
const actions = {
  addToBasket() {
    const bcSelectedStore = useBcSelectedStore()

    bcSelectedStore.listSelectedRoots.forEach(element => {
      const exists = findIndex(this.selected, [ 'id', element[bcSelectedStore.key] ])
      if (exists !== -1) { // replace existing element
        this.selected.splice(exists, 1)
      }

      this.selected.push({
        id: element[bcSelectedStore.key],
        element,
        children: bcSelectedStore.parentKey ? bcSelectedStore.listSelectedChildrenRecursive(element[bcSelectedStore.key]) : null
      })
    })
  },
  removeFromBasket(id) {
    const exists = findIndex(this.selected, [ 'id', id ])
    if (exists !== -1) { // replace existing element
      this.selected.splice(exists, 1)
    }
  }
}

export default defineStore({
  id: 'bcSelectedBasket',
  state,
  getters,
  actions,
});